import CONFIGS from "../configs";


export const getDetails = async (merchantCode) => {
    try {
        let data = { code: merchantCode };
    
       let baseURL = `http://${CONFIGS.API.HOST}:${CONFIGS.API.PORT}`;
       
        if(['sandbox','production'].includes(CONFIGS.MODE)){
            baseURL = `https://${CONFIGS.API.URL}`
        }

        baseURL += `/${CONFIGS.API.SERVICE}/Json/${CONFIGS.API.GET_MERCHANT_DETAILS_SERVICE}`;
                
        let response = await fetch(baseURL, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        let result = await response.json();
        return result;

    } catch (error) {
        throw error;
    }
}